import CollapsibleList from '@/components/component/Reuse/CollapsibleList/CollapsibleList.vue'
import constants from '@/libs/constant/constants'
import {getAdminMenuCount} from '@/libs/api/api'

export default {
  name: 'main-navigation-menu',
  props: {
    menuList: Array,
    clickedOn: String,
    menuItem: Object,
    fetchMenuItem: Function,
    className: String,
    updateCount: Object,
    changeUpdateCount: Function
  },
  components: {CollapsibleList},
  beforeMount() {
    this.getList()
  },
  watch: {
    updateCount (value) {
      if (value.isUpdate) {
        this.updateLeftCount(value)
      }
    }
  },
  data () {
    return {
      showUser: false,
      showInfo: false,
      userManagementList: [{  
          id:2,
          type: 'user',
          label: 'Overview',
          className: 'user'
        },
      {
        id:3,
        label: 'Users',
        type: 'user',
        className: 'user',
        contentCount: '0',
        category: 'USER'
      }],
      informationPortalList: [{
          id:2,
          label: 'Overview',
          type: 'info',
          className: 'info'
        },{
          id:3,
          label: 'Articles',
          contentCount: '0',
          type: 'info',
          className: 'info',
          category: 'ARTICLE'
        },
      {
        id:4,
        label: 'Authors',
        iconClass: 'nova-authorprofile',
        contentCount: '0',
        type: 'info',
        className: 'info',
        category: 'AUTHOR'
      },
    { 
      id:5,
      label: 'Publications',
      iconClass: 'nova-publication',
      contentCount: '0',
      type: 'info',
      className: 'info',
      category: 'PUBLICATION'
    },{
      id:6,
      label: 'Publishers',
      iconClass: 'nova-publisher',
      classLabel: 'nova-publisher',
      contentCount: '0',
      type: 'info',
      className: 'info',
      category: 'PUBLISHER'
    }]
    }
  },
  methods: {
    getList () {
      getAdminMenuCount().then(response => {
        this.userManagementList = [{  
          id:2,
          type: 'user',
          label: 'Overview',
          className: 'user'
        },
      {
        id:3,
        label: 'Users',
        type: 'user',
        className: 'user',
        contentCount: response.user || '0',
        category: 'USER'
      }]
        this.informationPortalList = [{
          id:2,
          label: 'Overview',
          type: 'info',
          className: 'info'
        },{
          id:3,
          label: 'Articles',
          contentCount: response.content || '0',
          type: 'info',
          className: 'info'
        },
      {
        id:4,
        label: 'Authors',
        iconClass: 'nova-authorprofile',
        contentCount: response.author || '0',
        type: 'info',
        className: 'info'
      },
    { 
      id:5,
      label: 'Publications',
      iconClass: 'nova-publication',
      contentCount: response.publication || '0',
      type: 'info',
      className: 'info'
    },{
      id:6,
      label: 'Publishers',
      iconClass: 'nova-publisher',
      classLabel: 'nova-publisher',
      contentCount: response.publisher || '0',
      type: 'info',
      className: 'info'
        }]
      }).catch(error => {
        console.warn('CountError', error)
      })
    }, 
    updateLeftCount (countToUpdate) {
      if (countToUpdate.category) {
        switch (countToUpdate.category) {
          case constants.ADMIN.Articles.value_without_s:
            this.informationPortalList.map(menuItem => {
              if (menuItem.id === 3) {
                menuItem.contentCount = countToUpdate.count === 0 ? '0': countToUpdate.count
              }
            })
          break
          case constants.ADMIN.Authors.value_without_s:
            this.informationPortalList.map(menuItem => {
              if (menuItem.id === 4) {
                menuItem.contentCount = countToUpdate.count === 0 ? '0': countToUpdate.count
              }
            })
          break
          case constants.ADMIN.Publications.value_without_s:
            this.informationPortalList.map(menuItem => {
              if (menuItem.id === 5) {
                menuItem.contentCount = countToUpdate.count === 0 ? '0': countToUpdate.count
              }
            })
          break
          case constants.ADMIN.Publishers.value_without_s:
            this.informationPortalList.map(menuItem => {
              if (menuItem.id === 6) {
                menuItem.contentCount = countToUpdate.count === 0 ? '0': countToUpdate.count
              }
            })
          break
          case constants.ADMIN.Users.value_without_s:
            this.userManagementList.map(menuItem => {
              if (menuItem.id === 3) {
                menuItem.contentCount = countToUpdate.count === 0 ? '0': countToUpdate.count
              }
            })
          break
        }
      }
      this.changeUpdateCount({isUpdate: false})
    }
  }
}